export default __webpack_public_path__ + "partner_10146d6.png";